import { useEffect, useRef } from "react";

/**
 * Returns a ref that is true if and only if the component is currently mounted.
 * Can be used to determine if a side effect is safe to run inside of an
 * callback that may be running after the component was (or is being) unmounted.
 */
export function useIsMounted(): React.RefObject<boolean> {
  const isMounted = useRef(true);

  useEffect(() => {
    // reset to `true` on mount in case the component is unmounted and
    // remounted via hot-module-replacement
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}
